<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="dispatchUnreciveOrder">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem
            @action="changeStatus"
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
          ></businessItem>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup
      class="bidPopUp"
      v-model="show"
      closeable
      round
      :style="{ height: '164px', width: '270px' }"
    >
      <p class="popUpTitle">安装人员</p>
      <div class="pickUnit" @click="showUnit = true">
        <p>{{ currentUnit.name }}</p>
      </div>
      <van-button class="unitButton" type="primary" @click="submit"
        >指派</van-button
      >
    </van-popup>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择安装人员"
        :columns="unitList"
        @confirm="onConfirm"
        value-key="name"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup v-model="showRefund" position="center" class="showRefund">
      <div class="inner">
        <p>退单人员：{{ chargeBack.returnPerson || "--" }}</p>
        <p>退单时间：{{ chargeBack.returnTime || "--" }}</p>
        <p>退单原因：{{ chargeBack.returnReason || "--" }}</p>
        <p @click="closeRefund" class="btn">确定</p>
      </div>
    </van-popup>
    <van-notify v-model="showNotice">
      <span>请选择安装人员</span>
    </van-notify>
  </div>
</template>

<script>
import {
  dispatchOrderList,
  dispatchWorkerList,
  dispatchOrderAssgin,
  dispatchChargeBack,
} from "@/utils/network/interface";
import businessItem from "./item";
export default {
  name: "dispatchUnreciveOrder",
  components: {
    businessItem,
  },
  props: {
    keyWord: String,
  },
  data() {
    return {
      tableList: [],
      show: false,
      currentRow: {},
      unitList: [],
      currentUnit: {},
      columns: [{ text: "杭州" }, { text: "宁波" }, { text: "温州" }],
      showUnit: false,
      showNotice: false,
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      chargeBack: {},
      showRefund: false,
    };
  },
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.finished = false;
      this.tableList = [];
    },
  },
  created() {
    this.getUnitList();
  },
  mounted() {},
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { type: 1, pageSize, pageNum, bizName: this.keyWord };
        dispatchOrderList(obj)
          .then((res) => {
            if (res.code === 200) {
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = { type: 1, pageSize: 10, pageNum: 1, bizName: this.keyWord };
      dispatchOrderList(obj)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            this.tableList = res.rows;
            this.pageInfo.pageNum++;
            this.pageInfo.total = res.total;
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
    },
    getUnitList() {
      dispatchWorkerList().then((res) => {
        console.log(res);
        this.unitList = res.data;
      });
    },
    changeStatus(data, methods) {
      this.currentRow = data;
      // console.log(data)
      if (methods == 2) {
        this.show = true;
      } else if (methods == 3) {
        this.showRefund = true;
        dispatchChargeBack({ id: data.id }).then((res) => {
          if (res.code === 200) {
            this.chargeBack = res.data[0];
          } else {
          }
        });
      }
    },
    onConfirm(value, index) {
      // console.log(value,index)
      this.currentUnit = this.unitList[index];
      this.showUnit = false;
    },
    onCancel() {
      this.showUnit = false;
    },
    submit() {
      if (!this.currentUnit.id) {
        this.showNotice = true;
        setTimeout(() => {
          this.showNotice = false;
        }, 2000);
      } else {
        let params = {
          acceptPerson: this.currentUnit.name,
          personId: this.currentUnit.id,
          id: this.currentRow.id,
        };
        dispatchOrderAssgin(params).then((res) => {
          // console.log(res)
          if (res.code !== 200) {
            this.$toast({
              type: "fail",
              message: res.msg,
            });
          } else {
            this.currentRow = {};
            this.currentUnit = {};
            this.show = false;
            this.pageInfo.pageNum = 1;
            this.getData();
          }
        });
      }
    },
    closeRefund() {
      this.showRefund = false;
      this.chargeBack = {};
    },
  },
};
</script>

<style lang="less" scoped>
.dispatchUnreciveOrder {
  .bidPopUp {
    padding: 20px;
    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../../assets/accountant/selectDown.png")
        calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 25px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;
      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 0 auto;
      border: 1px solid #44b1f9;
    }
  }
  .showRefund {
    width: 320px;
    height: 210px;
    background: #ffffff;
    border-radius: 20px;
    padding: 40px 20px 0;
    line-height: 2;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    color: #666666;
    .btn {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      line-height: 2;
      margin: 30px auto 0;
    }
  }
}
</style>